import React, { useRef } from "react";
import { IconButton, Tooltip, withStyles } from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import { ConfirmDelete } from "../../../../../../components";

const styles = (theme) => ({
  cta: {
    marginLeft: theme.spacing(1),
    '&.MuiIconButton-sizeSmall.MuiIconButton-edgeEnd': {
      marginRight: theme.spacing(1),
    }
  },
});

const HouseholdPortfolioTableTrash = (props) => {
  const { classes, adminView, portfolio, archivePortfolio } = props;

  if (adminView) return null;

  const confirmDeleteRef = useRef();

  const { uuid, onboarded, onboardStatus } = portfolio;

  const isLocked = onboarded ||
    [
      "forms-generated",
      "forms-submitted",
      "forms-signed",
      "onboarded",
    ].includes(onboardStatus);

  if (isLocked) return null;

  return (
    <ConfirmDelete
      dialogName="delete-portfolio"
      dialogTitle="Confirm"
      dialogText="Are you sure you want to delete this portfolio?"
      dialogConfirmedCallback={() => archivePortfolio(uuid)}
      ref={confirmDeleteRef}
    >
      <Tooltip title="Delete" placement="top">
        <IconButton
          aria-label="delete"
          size="small"
          className={classes.cta}
          onClick={() => confirmDeleteRef.current.handleModalOpen()}
        >
          <Delete />
        </IconButton>
      </Tooltip>
    </ConfirmDelete>
  );
};

export default withStyles(styles)(HouseholdPortfolioTableTrash);



// WEBPACK FOOTER //
// ./src/containers/HouseholdDetail/components/PortfolioTable/components/Trash/index.jsx